import ProductItemView from "../../products-list/view/product-item.js";

export default class ProductTitle extends ProductItemView {
  constructor(element) {
    super(element);

    this._quantityElement = null;
    this._quantityInput = null;
    this._totalPerPalletElement = null;
    this._totalVolumeElement = null;
    this._totalItemsElement = null;
    this._totalAreaElement = null;
    this._currentPriceElement = null;
    this._oldPriceElement = null;
    this._productFeaturesElement = null;
    this._featuresListElement = null;
    this._productInfoContainerElement = null;
  }

  getQuantityElement() {
    if (!this._quantityElement) {
      this._quantityElement = this._element.querySelector(`.product-quantity`);
    }

    return this._quantityElement;
  }

  getTotalPerPalletElement() {
    if (!this._totalPerPalletElement) {
      this._totalPerPalletElement = this._element.querySelector(`.product-info__quantity-number`);
    }

    return this._totalPerPalletElement;
  }

  getTotalVolumeElement() {
    if (!this._totalVolumeElement) {
      this._totalVolumeElement = this._element.querySelector(`.product-info__quantity-volume`);
    }

    return this._totalVolumeElement;
  }

  getTotalItemsElement() {
    if (!this._totalItemsElement) {
      this._totalItemsElement = this._element.querySelector(`.product-info__total-items-quantity`);
    }

    return this._totalItemsElement;
  }

  getTotalAreaElement() {
    if (!this._totalAreaElement) {
      this._totalAreaElement = this._element.querySelector(`.product-info__quantity-area`);
    }

    return this._totalAreaElement;
  }

  getCurrentPriceElement() {
    if (!this._currentPriceElement) {
      this._currentPriceElement = this._element.querySelector(`.product-total__current`);
    }

    return this._currentPriceElement;
  }

  getOldPriceElement() {
    if (!this._oldPriceElement) {
      this._oldPriceElement = this._element.querySelector(`.product-total__old`);
    }

    return this._oldPriceElement;
  }

  getQuantity() {
    if (!this._quantityInput) {
      this._quantityInput = this._element.querySelector(`input`);
    }

    return +this._quantityInput.value;
  }

  getProductFeaturesElement() {
    if (!this._productFeaturesElement) {
      this._productFeaturesElement = this._element.querySelector(`.product-features`);
    }

    return this._productFeaturesElement;
  }

  getFeaturesListElement() {
    if (!this._featuresListElement) {
      this._featuresListElement = this._element.querySelector(`.product-features-list`);
    }

    return this._featuresListElement;
  }

  getProductInfoContainerElement() {
    if (!this._productInfoContainerElement) {
      this._productInfoContainerElement = this._element.querySelector(`.product-info-container`);
    }

    return this._productInfoContainerElement;
  }

  getPrice() {
    return +this._element.dataset.price;
  }

  getOldPrice() {
    return +this._element.dataset.oldPrice;
  }

  getProductId() {
    return +this._element.dataset.productId;
  }

  getPerPallet() {
    return +this._element.dataset.perPallet;
  }

  getVolume() {
    return +this._element.dataset.volume;
  }

  getPackageItems() {
    return +this._element.dataset.packageItems;
  }

  getPackageM2() {
    return parseFloat(this._element.dataset.packageM2);
  }

  getTotalPerPallet() {
    return (this.getTotalPerPalletElement()) ?
      +this.getTotalPerPalletElement().textContent.replace(/\D/g, ``) :
      null;
  }

  setTotalPerPallet(value) {
    if (!this.getTotalPerPalletElement()) {
      return;
    }

    this.getTotalPerPalletElement().textContent = value;
  }

  getTotalVolume() {
    return (this.getTotalVolumeElement()) ?
      +this.getTotalVolumeElement().textContent.replace(`,`, `.`) :
      null;
  }

  setTotalVolume(value) {
    if (!this.getTotalVolumeElement()) {
      return;
    }

    this.getTotalVolumeElement().textContent = (value % 1) === 0 ?
      value : value.toFixed(2);
  }

  setTotalPackageItems(value) {
    if (!this.getTotalItemsElement()) {
      return;
    }

    this.getTotalItemsElement().textContent = value;
  }

  getTotalArea() {
    return (this.getTotalAreaElement()) ?
      +this.getTotalAreaElement().textContent :
      null;
  }

  setTotalArea(value) {
    if (!this.getTotalAreaElement()) {
      return;
    }

    this.getTotalAreaElement().textContent = (value % 1) === 0 ?
      value : value.toFixed(2);
  }

  getTotalCurrentPrice() {
    return (this.getCurrentPriceElement()) ?
      +this.getCurrentPriceElement().textContent.replace(/\D/g, ``) :
      null;
  }

  setTotalCurrentPrice(value) {
    if (this.getCurrentPriceElement()) {
      this.getCurrentPriceElement().textContent = value;
    }
  }

  getTotalOldPrice() {
    return (this.getOldPriceElement()) ?
      +this.getOldPriceElement().textContent.replace(/\D/g, ``) :
      null;
  }

  setTotalOldPrice(value) {
    if (this.getOldPriceElement()) {
      this.getOldPriceElement().textContent = value;
    }
  }
}
